import React, { PureComponent } from 'react';

import QuickAddToCart from 'yoda-site-components/lib/components/QuickAddTocart/QuickAddToCart';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

export default class EventListener extends PureComponent {
    // eslint-disable-line react/prefer-stateless-function
    render() {
        const quickAddToCartStyle = dt(['!hidden']);
        return (
            <QuickAddToCart
                miniPDPTriggerEvent="miniPDP.open"
                location="EventListener"
                enableMiniPDP
                themeConfig={{
                    wrapperClass: quickAddToCartStyle,
                }}
            />
        );
    }
}
